var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"safieStyle",staticStyle:{"width":"100%","position":"absolute","height":"auto !important"}},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":require("../assets/img/safieImage.png"),"alt":"Safie Image"}})])])
}]

export { render, staticRenderFns }